import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { withRouter } from "react-router-dom";

const ScrollToTop = withRouter(({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
      toast.dismiss();
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
});

export default ScrollToTop;
